import { createTokens } from "@tamagui/core";
import * as iconTokens from "../Icon/Icon.tokens";
import * as typographyTokens from "../Typography/Typography.tokens";
import { colors } from "./colors.mjs";
const tokens = createTokens({
  color: {
    ...colors
  },
  radius: {
    ...typographyTokens.linkRadiusTokens
  },
  size: {
    ...iconTokens.sizeTokens,
    ...typographyTokens.headerSizeTokens,
    ...typographyTokens.headerLineHeightTokens,
    ...typographyTokens.textSizeTokens,
    ...typographyTokens.textLineHeightTokens
  },
  space: {
    ...typographyTokens.linkSpaceTokens
  },
  zIndex: {
    modal: 100
  }
});
export { tokens };